<template>
  <div class="charging-voucher-page">
    <div v-if="curNav === 'CharingCenter'">
      <CharingCenter />
    </div>
    <div v-else-if="curNav === 'MyCoupons'">
      <MyCoupons />
    </div>
    <div v-else-if="curNav === 'DiscountCoupon'">
      <DiscountCoupon />
    </div>
    <div v-else-if="curNav === 'MyShareCode'">
      <MyShareCode />
    </div>

    <BottomNavBar
      v-if="showBottomNavBar"
      :options="navBarOptions"
      :cur-nav="curNav"
      @click="handleNavBarClick"
    />
  </div>
</template>

<script>
import BottomNavBar from '../chargingVoucher/components/BottomNavBar.vue';
import CharingCenter from './components/CharingCenter.vue';
import MyCoupons from './components/MyCoupons.vue';
import DiscountCoupon from './components/DiscountCoupon.vue';
import MyShareCode from './components/MyShareCode.vue';
import IconCharingCenterDefault from '@/assets/img/chargingVoucher/home-default.png';
import IconCharingCenterSelected from '@/assets/img/chargingVoucher/home-selected.png';
import IconMyCouponsDefault from '@/assets/img/chargingVoucher/my-coupons-default.png';
import IconMyCouponsSelected from '@/assets/img/chargingVoucher/my-coupons-selected.png';
import IconRedEnvelopeDefault from '@/assets/img/chargingVoucher/red-envelope-default.png';
import IconRedEnvelopeSelected from '@/assets/img/chargingVoucher/red-envelope-selected.png';
import IconMyShareCodeDefault from '@/assets/img/chargingVoucher/icon-my-share-code-default.png';
import IconMyShareCodeSelected from '@/assets/img/chargingVoucher/icon-my-share-code-seleted.png';
import tokenMixin from './mixins/tokenMixin.js';

export default {
  name: 'ChargingVoucher',
  components: {
    BottomNavBar,
    CharingCenter,
    MyCoupons,
    DiscountCoupon,
    MyShareCode
  },
  mixins: [tokenMixin],
  data() {
    return {
      curNav: '',
      navBarOptions: [
        {
          text: '购券中心',
          defaultIcon: IconCharingCenterDefault,
          selectedIcon: IconCharingCenterSelected,
          key: 'CharingCenter'
        },
        {
          text: '我的充电券',
          defaultIcon: IconMyCouponsDefault,
          selectedIcon: IconMyCouponsSelected,
          key: 'MyCoupons'
        },
        {
          text: '我的优惠券',
          defaultIcon: IconRedEnvelopeDefault,
          selectedIcon: IconRedEnvelopeSelected,
          key: 'DiscountCoupon'
        },
        {
          text: '我的分享码',
          defaultIcon: IconMyShareCodeDefault,
          selectedIcon: IconMyShareCodeSelected,
          key: 'MyShareCode'
        }
      ],
      source: ''
    };
  },
  computed: {
    showBottomNavBar() {
      return true;
    }
  },
  mounted() {
    const navKey =
      localStorage.getItem('_nav') || this.navBarOptions[0]?.key || '';
    this.handleNavBarClick(navKey);
    localStorage.removeItem('_nav');
  },
  beforeDestroy() {
    localStorage.setItem('_nav', this.curNav);
  },
  methods: {
    init() {
      const query = this.$route.query;
      // 处理从小程序入口跳转过来
      if (Object.keys(query).length) {
        // 基础信息
        const phone = this.$route.query.phone || '';
        if (phone) localStorage.setItem('_phone', phone);
        // 支付回调
        const orderNo = this.$route.query.orderNo || '';
        const isCallBack = this.$route.query.isCallBack || '';
        if (orderNo) localStorage.setItem('_orderNo', orderNo);
        if (isCallBack) localStorage.setItem('_isCallBack', isCallBack);
        // 跳转来源
        const source = this.$route.query.source || '';
        if (source) localStorage.setItem('_source', source);

        this.$router.replace({
          name: 'ChargingVoucherAgency',
          query: {
            encryptAgencyCode: query.encryptAgencyCode,
            source: query.source
          }
        });
      }
      this.source = localStorage.getItem('_source') || '';
    },
    handleNavBarClick(key) {
      this.curNav = key;
      const nav = this.navBarOptions.find((item) => item.key === key);
      document.title = nav?.text || '';
      localStorage.setItem('_nav', this.curNav);
      console.log(this.curNav);
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../chargingVoucher/styles/chargingVoucherCenter.scss';
</style>
